module.exports = __webpack_public_path__ + "img/idea_reality.505f650.jpg";